<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="E.M.O" key="1">
        <g-master name="forms"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  ref="master"
                  @action="masterAction"
                  modalWidth="90%"
                  @params="paramsTable"
        >
          <template slot="customButton">
            <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
          </template>
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Trabajador')"
                          :formItemConfig="fiOptions"
                          endpoint="empleados"
                          ref="trabajador"
                          :params="{estado_activo: true}"
                          :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                >
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('IPS')"
                            ref="ipsList"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['ips', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                            :params="id_h_ips"
                >
                </g-dropdown>
              </a-col>
              <a-col v-if="mostrarOtraIps" v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('¿Cuál?')">
                  <a-textarea style="width: 100%"
                              autoSize
                              v-decorator="['other_ips', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('Tipo EMO')"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['emo_type', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                            :params="id_h_emo"
                >
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Tipos')" :has-feedback="false">
                  <a-checkbox
                    v-decorator="['lifestyles', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                    Cardiovasculares
                  </a-checkbox>
                  <a-checkbox
                    v-decorator="['osteomuscular', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                    Biomecanico
                  </a-checkbox>
                  <a-checkbox
                    v-decorator="['psychosocial', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                    Psicosocial
                  </a-checkbox>
                  <a-checkbox
                    v-decorator="['biological', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                    Biológico
                  </a-checkbox>
                  <a-checkbox
                    v-decorator="['visual', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                    Visual
                  </a-checkbox>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha. recomendaciones')">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['recommendation_date', { rules: [{ required: false}] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Recomendaciones')">
                  <a-textarea style="width: 100%"
                              autoSize
                              v-decorator="['recommendations', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Compromiso')" :has-feedback="false">
                  <a-checkbox
                    v-decorator="['commitment', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                  </a-checkbox>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha inicio')">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['initial_date', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha fin')">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['end_date', { rules: [{ required: isRequiredFechaFin, message: 'Valor requerido'}] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Responsable')"
                          ref="responsable_reintegro"
                          :formItemConfig="fiOptions"
                          endpoint="empleados"
                          :params="{filtra_por_cargo: true}"
                          :decorator="['responsable', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                >
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Obs. seguimiento')">
                  <a-textarea style="width: 100%"
                              autoSize
                              v-decorator="['observations', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha de remisión a EPS')">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['remission_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Caso cerrado')" :has-feedback="false">
                  <a-checkbox
                    v-decorator="['close_case', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                  </a-checkbox>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Observaciones generales')">
                  <a-textarea style="width: 100%"
                              autoSize
                              v-decorator="['general_remarks', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  export default {
    data () {
      return {
        isRequiredFechaFin: this.$getConfigValue('NOTIFICACIONES_EMO', 'NO') === 'SI',
        mostrarOtraIps: false,
        paramsT: {},
        endpointExcel: 'emo_/downloadExcel',
        fileNameExcel: 'EMO',
        id_h_emo: {
          h_lookup_type: 'TIPO_EMO'
        },
        id_h_ips: {
          h_lookup_type: 'REINCORPORACIONES_IPS'
        },
        id_h_refund_type: {
          h_lookup_type: 'REINCORPORACIONES_TIPO_REINTEGRO'
        },
        id_h_status: {
          h_lookup_type: 'REINCORPORACIONES_ESTADO'
        },
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 12},
        master: {
          endpoint: 'emo',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Nombre del trabajador', dataIndex: 'nombre_completo_empleado', sorter: true},
              {title: 'Fecha de ingreso del trabajador', dataIndex: 'fecha_ingreso_trabajador', sorter: true},
              {title: 'Doc. identidad', dataIndex: 'cedula_empleado', sorter: true},
              {title: 'Cargo', dataIndex: 'cargo_trabajador', sorter: true},
              {title: 'Lugar de trabajo', dataIndex: 'desc_id_h_att_2', sorter: true},
              {title: 'IPS', dataIndex: 'ips_desc', sorter: true},
              {title: 'Tipo E.M.O', dataIndex: 'tipo_emo', sorter: true},
              {title: 'Cardiovasculares', dataIndex: 'lifestyles_desc', sorter: true},
              {title: 'Biomecanico', dataIndex: 'osteomuscular_desc', sorter: true},
              {title: 'Psicosocial', dataIndex: 'psychosocial_desc', sorter: true},
              {title: 'Biologico', dataIndex: 'biological_desc', sorter: true},
              {title: 'Visual', dataIndex: 'visual_desc', sorter: true},
              {title: 'Fecha recomendaciones', dataIndex: 'recommendation_date_desc', sorter: true},
              {title: 'Recomendaciones', dataIndex: 'recommendations', sorter: true},
              {title: 'Compromiso', dataIndex: 'commitment_desc', sorter: true},
              {title: 'Fecha inicio', dataIndex: 'initial_date_desc', sorter: true},
              {title: 'Fecha fin', dataIndex: 'end_date_desc', sorter: true},
              {title: 'Responsable', dataIndex: 'responsable_desc', sorter: true},
              {title: 'Observaciones', dataIndex: 'observations', sorter: true},
              {title: 'Fecha remisión EPS', dataIndex: 'remission_date_desc', sorter: true},
              {title: 'Caso cerrado', dataIndex: 'close_case_desc', sorter: true},
              {title: 'Observaciones generales', dataIndex: 'general_remarks', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          }
        }
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.mostrarOtraIps = false
            break
          case 'masterEdit':
            if (!JsUtils.isEmpty(action.record.id_emp)) {
              this.$refs.trabajador && this.$refs.trabajador.handleSearch(action.record.id_emp)
            }
            if (!JsUtils.isEmpty(action.record.responsable)) {
              this.$refs.responsable_reintegro && this.$refs.responsable_reintegro.handleSearch(action.record.responsable)
            }
            if (!this.$isEmpty(action.record.codigo_ips)) {
              if (action.record.codigo_ips === 'OTR') {
                this.mostrarOtraIps = true
                setTimeout(() => {
                  this.$refs.master.modal.form.setFieldsValue({
                    other_ips: action.record.other_ips
                  })
                }, 300)
              } else {
                this.mostrarOtraIps = false
              }
            }
            break
          case 'fieldsChange':
            if (Object.keys(action.changedFields).length > 1) {
              break
            }
            if (!this.$isEmpty(action.changedFields.ips)) {
              let valorSeleccionado = this.$refs.ipsList.options.filter(item => item.value == action.changedFields.ips.value)
              if (valorSeleccionado.length > 0) {
                let ips = valorSeleccionado[0]
                this.mostrarOtraIps = ips.code === 'OTR'
              } else {
                this.mostrarOtraIps = false
              }
            }
            break
        }
      }
    },
    computed: {
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/MatrizSeguimiento/EMO.vue